






























































































import {
  computed, defineComponent, onMounted, onUnmounted, ref,
} from '@nuxtjs/composition-api';
import { SfCallToAction, SfHeading } from '@storefront-ui/vue';
import { storeToRefs } from 'pinia';
import SvgImage from '~/components/General/SvgImage.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import type { CustomerOrder } from '~/composables';
import { useUser } from '~/composables';
import { useUserOrder } from '~/modules/customer/composables/useUserOrder';
import { useThankYouStore } from '~/stores/thankyou';
import OrderInfo from '../../components/OrderInfo.vue';
import OrderStatus from '../../components/OrderStatus.vue';
import CardPaymentComponent from '../../components/payments/CardPaymentComponent.vue';
import PixPaymentComponent from '../../components/payments/PixPaymentComponent.vue';
import SlipPaymentComponent from '../../components/payments/SlipPaymentComponent.vue';

export default defineComponent({
  components: {
    SfHeading,
    SfCallToAction,
    PixPaymentComponent,
    SlipPaymentComponent,
    CardPaymentComponent,
    JetUiButton,
    SvgImage,
    OrderInfo,
    OrderStatus,
    SkeletonLoader,
  },
  setup() {
    const thankYouStore = useThankYouStore();
    const {
      orderNumber, pixData, slipData, price, selectedCardObject, success, cart,
    } = storeToRefs(thankYouStore);
    const { user, isAuthenticated } = useUser();
    const loaded = ref(false);
    const { search } = useUserOrder();
    const loading = ref(true);
    const asyncData = ref<CustomerOrder>(null);
    const paymentMethod = computed(() => {
      if (pixData.value && pixData.value.txid) {
        return 'Pix';
      } if (slipData.value) {
        return 'Boleto';
      }
      return 'Cartão de crédito';
    });
    const username = computed(() => user.value?.firstname ?? 'Olá');
    let interval = null;
    let timeout = null;

    const fetchData = async () => {
      const orderResult = await search({ filter: { number: { eq: orderNumber.value } } });
      if (!orderResult) return;
      const order = orderResult.items[0] ?? null;
      asyncData.value = order;
    };

    onMounted(async () => {
      thankYouStore.loadStoredState();
      await fetchData();

      if (!orderNumber.value) {
        window.location.href = '/';
        return;
      }

      loaded.value = true;
      interval = setInterval(() => {
        fetchData()
      }, 20000);
      timeout = setTimeout(() => {
        clearInterval(interval)
      }, 1200000);
    });

    onUnmounted(() => {
      clearInterval(interval);
      clearTimeout(timeout);
    });

    const statusMapping = {
      Pendente: { color: 'icon-blue', index: 0, icon: 'pending_payment' },
      Aprovado: { color: 'icon-blue', index: 1, icon: 'approved_payment' },
      'Em separação': { color: 'icon-blue', index: 2, icon: 'preparing_order' },
      Enviado: { color: 'icon-green', index: 3, icon: 'check' },
      Fechado: { color: 'icon-red', index: 4, icon: 'cancel_cross' },
      Cancelado: { color: 'icon-red', index: 5, icon: 'cancel_cross' },
    };

    const statusData = computed(() => {
      const status = asyncData.value?.status;
      return statusMapping[status] || { color: '', index: 0 };
    });

    const index = computed(() => statusData.value.index);

    const openHome = () => {
      window.location.href = '/';
    };
    return {
      index,
      orderNumber,
      pixData,
      slipData,
      price,
      selectedCardObject,
      success,
      user,
      isAuthenticated,
      username,
      cart,
      paymentMethod,
      openHome,
      loading,
      loaded,
    };
  },
});
